export default function LoadingSkeleton() {
  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-background">
      <div className="w-full max-w-md p-8 space-y-8">
        <div className="space-y-4 mt-8">
          <div className="h-4 bg-surface/60 rounded-md animate-pulse opacity-0 animate-[fadeInUp_0.6s_ease-out_0ms_forwards]"></div>
          <div className="h-4 bg-surface/60 rounded-md animate-pulse opacity-0 animate-[fadeInUp_0.6s_ease-out_150ms_forwards]"></div>
          <div className="h-4 bg-surface/60 rounded-md animate-pulse w-3/4 opacity-0 animate-[fadeInUp_0.6s_ease-out_300ms_forwards]"></div>
          <div className="h-10 bg-surface/60 rounded-md animate-pulse mt-6 opacity-0 animate-[fadeInUp_0.6s_ease-out_450ms_forwards]"></div>
        </div>
      </div>
    </div>
  );
}
